import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "content", "title"]

  open(event) {
    const seasonId = event.currentTarget.dataset.seasonId
    this.showModal(seasonId)
  }

  close(event) {
    if (event) {
      event.preventDefault()
    }
    this.modalTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
  }

  showModal(seasonId) {
    // Dispatch event to notify other controllers (like seasons-grid) that season modal is opening
    document.dispatchEvent(new CustomEvent('season-modal:opening'))
    
    // Show the modal
    this.modalTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
    
    // Load season-specific content
    this.loadSeasonDetails(seasonId)
  }

  async loadSeasonDetails(seasonId) {
    try {
      
      // Reset to loading state
      this.contentTarget.innerHTML = `
        <div class="text-center py-8">
          <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-emerald-400 mx-auto"></div>
          <p class="text-slate-400 mt-2">Loading season details...</p>
        </div>
      `
      
      // Get the current TV show slug from the URL
      const currentPath = window.location.pathname
      const tvShowSlug = currentPath.split('/')[1] // Gets the slug from /:id path
      const url = `/${tvShowSlug}/season/${seasonId}`
      
      
      // Make AJAX request to load season details
      const response = await fetch(url, {
        headers: {
          'Accept': 'text/html',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      
      
      if (response.ok) {
        const html = await response.text()
        this.contentTarget.innerHTML = html
        
        // Update modal title with season name
        const seasonButton = document.querySelector(`[data-season-id="${seasonId}"]`)
        const seasonCard = seasonButton?.closest('.bg-slate-800')
        const seasonName = seasonCard?.querySelector('h3')?.textContent || `Season ${seasonId}`
        if (this.hasTitle) {
          this.titleTarget.textContent = `${seasonName} Details`
        }
      } else {
        throw new Error(`Failed to load season details: ${response.status}`)
      }
    } catch (error) {
      this.contentTarget.innerHTML = `
        <div class="text-center py-8">
          <p class="text-red-400">Failed to load season details: ${error.message}</p>
          <button class="mt-2 px-4 py-2 bg-indigo-600 hover:bg-indigo-700 rounded text-white" 
                  data-action="click->season-modal#close">Close</button>
        </div>
      `
    }
  }


  // Close modal when clicking outside
  backdropClick(event) {
    if (event.target === this.modalTarget) {
      this.close()
    }
  }

  // Prevent modal from closing when clicking inside
  stopPropagation(event) {
    event.stopPropagation()
  }
}